import React from "react";
import { IconButton } from "@mui/material";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { HEADER_ICON_BUTTON_SX } from "app/components/Layout/filterToolbarStyles";

type KnowledgeButtonProps = {
  active?: boolean;
  onClick: () => void;
};

export function KnowledgeButton({ active = false, onClick }: KnowledgeButtonProps) {
  return (
    <IconButton
      aria-label="Open help and guides"
      size="small"
      onClick={onClick}
      sx={{
        ...HEADER_ICON_BUTTON_SX,
        ...(active
          ? { borderColor: "#5fa67a", bgcolor: "#f0fdf4" }
          : {}),
      }}
    >
      <MenuBookOutlinedIcon fontSize="small" />
    </IconButton>
  );
}
